import { RateAndReviewForm } from '../rateAndReviewForm/rateAndReviewForm';
import { RateAndReviewModal } from '../rateAndReviewModal/rateAndReviewModal';
import type { RateAndReviewModalVariantProps } from '../rateAndReviewModalVariant';
import { ReviewProductHeader } from '../reviewProductHeader/reviewProductHeader';
import { ReviewSubmitted } from '../reviewSubmitted/reviewSubmitted';

export type RateAndReviewFormModalProps = RateAndReviewModalVariantProps;

/** A/B test variant A: the modal shell with every question at once. */
export function RateAndReviewFormModal({
  activityOptions,
  brand,
  category,
  feelingOptions,
  imageUrl,
  isMobile,
  isSubmitted = false,
  isSubmitting,
  moreToReview,
  onChange,
  onRequestClose,
  onReviewProduct,
  onSubmit,
  open,
  productName,
  testId,
  title,
  value,
}: RateAndReviewFormModalProps) {
  return (
    <RateAndReviewModal
      isMobile={isMobile}
      onRequestClose={onRequestClose}
      open={open}
      productHeader={
        !isSubmitted && (
          <ReviewProductHeader
            brand={brand}
            category={category}
            imageUrl={imageUrl}
            name={productName}
            size="compact"
          />
        )
      }
      testId={testId}
      title={title}
    >
      {isSubmitted ? (
        <ReviewSubmitted
          moreToReview={moreToReview}
          onDone={onRequestClose}
          onReviewProduct={onReviewProduct}
          productName={productName}
          rating={value.rating}
        />
      ) : (
        <RateAndReviewForm
          activityOptions={activityOptions}
          feelingOptions={feelingOptions}
          isSubmitting={isSubmitting}
          onChange={onChange}
          onSubmit={onSubmit}
          value={value}
        />
      )}
    </RateAndReviewModal>
  );
}
